export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";